// extracted by mini-css-extract-plugin
export default {"newsItem":"styles_news-item__ZF4pz","newsTitle":"styles_news-title__M1JGH"};